import React from 'react';
import {Navigate} from 'react-router-dom';

import {LayoutSidebar} from '../../Layout';
import {useFicha21} from '../../context/UserModulesContext';
import {LearnContent} from './LearnContent';

// Guard de `/aprende`: la página, su entrada en el menú y el lanzador viven sólo en la 2.1 (contrato
// §1). En el marco clásico se va al listado de clientes, igual que `LinesView` manda a su pantalla
// del clásico. Hasta que llegan los módulos no se decide nada: redirigir con el flag todavía en false
// rebotaría a un usuario 2.1 por un valor que no llegó (mismo patrón que `ClientLines`).
//
// Una persona de la 2.1 sin la página habilitada (`enabled: false`: con el flag apagado, todo el que
// no es superadmin) también se va al listado: lo decide la página cuando llega su payload.
function LearnGuard() {
    const {ficha21, loaded} = useFicha21();

    if (!loaded) return null;
    if (!ficha21) return <Navigate to="/agency/clients" replace/>;

    return <LearnContent/>;
}

export function LearnPage() {
    return (
        <div className="app-content">
            <LayoutSidebar/>
            <LearnGuard/>
        </div>
    );
}

export default LearnPage;
